<template>
  <div>
    <loader v-if="!isContentLoaded" :is-visible="!isContentLoaded"></loader>
    <b-row v-if="isContentLoaded">
      <b-col md="12">
        <apex-line-chart :data-object="reportData.customerCountByYears"></apex-line-chart>
      </b-col>
      <b-col md="6" v-if="reportData.customerCountByReference.series.length > 0">
        <apex-pie-chart :data-object="reportData.customerCountByReference"></apex-pie-chart>
      </b-col>
      <b-col md="6" v-if="reportData.customerCountByHaveAppointment.series.length > 0">
        <apex-pie-chart :data-object="reportData.customerCountByHaveAppointment"></apex-pie-chart>
      </b-col>
      <b-col md="6" v-if="reportData.customerCountByHaveBill.series.length > 0">
        <apex-pie-chart :data-object="reportData.customerCountByHaveBill"></apex-pie-chart>
      </b-col>
      <b-col md="6" v-if="reportData.customerCountByGender.series.length > 0">
        <apex-pie-chart :data-object="reportData.customerCountByGender"></apex-pie-chart>
      </b-col>
      <b-col md="6" v-if="reportData.customerCountByType.series.length > 0">
        <apex-pie-chart :data-object="reportData.customerCountByType"></apex-pie-chart>
      </b-col>
      <b-col md="6" v-if="reportData.customerCountByAge.series.length > 0">
        <apex-pie-chart :data-object="reportData.customerCountByAge"></apex-pie-chart>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import reportService from '../../../services/report';

  import Loader from '../../../components/shared/Loader';
  import apexPieChart from '../../../components/apexCharts/ApexPieChart';
  import apexLineChart from '../../../components/apexCharts/ApexLineChart';

  export default {
    name: 'CustomerTrend',
    props: {
      getPayload: String
    },
    components: {
      Loader,
      apexPieChart,
      apexLineChart
    },
    data() {
      return {
        reportData: {},
        pageName: 'customer',
        isContentLoaded: false,
      }
    },
    methods: {
      getData(url) {
        this.reportData = {};
        reportService.getReportData(url, this.pageName)
          .then(response => {
            if (response) {
              this.reportData = response;
            }
            else {
              this.$toastr.error(this.$t("error"));
            }
          }).finally(() => this.isContentLoaded = true)
      },
    },
    computed: {
      url: function () {
        return this.getPayload;
      },
    },
    watch: {
      url: {
        handler: function (val) {
          this.isContentLoaded = false
          this.getData(val);
        },
        immediate: true
      }
    },

    mounted: function () {
    }
  }
</script>
